import {Paper, Table, TableBody, TableContainer, TableHead, TableRow,} from "@mui/material";
import React, {useMemo} from "react";
import {TableComponents, TableVirtuoso} from "react-virtuoso";
import {createFixedHeaderContent, TableColumnData} from "./TableColumnData";
import {deepmerge} from "@mui/utils";

function createRowContent<R>(columns: TableColumnData<R>[], id: (row: R) => any): (index: number, row: R) => React.ReactNode {
    return (rowIndex, row) => (
        <React.Fragment key={id(row)}>
            {columns.map(column => (
                <React.Fragment key={column.key}>{column.cell(row, rowIndex)}</React.Fragment>
            ))}
        </React.Fragment>
    );
}

export const SHOW_ON_HOVER_CLASS_NAME = 'show-on-hover';

function createVirtuosoTableComponents<R>(): TableComponents<R> {
    return {
        Scroller: React.forwardRef<HTMLDivElement>((props, ref) => (
            <TableContainer component={Paper} {...props} ref={ref} sx={{mt: 3}}/>
        )),
        Table: (props) => (
            <Table {...deepmerge({sx: {[`& tr:hover .${SHOW_ON_HOVER_CLASS_NAME}`]: {opacity: 1}}}, props)}  />
        ),
        TableHead: React.forwardRef<HTMLTableSectionElement>((props, ref) => (
            <TableHead {...props} ref={ref}/>
        )),
        TableRow: (props) => (
            <TableRow {...props}  />
        ),
        TableBody: React.forwardRef<HTMLTableSectionElement>((props, ref) => (
            <TableBody {...props} ref={ref}/>
        )),
    }
}

export function VirtualTable<R>({rows, id, columns}: {
    columns: TableColumnData<R>[],
    rows: R[],
    id: (row: R) => any,
}) {

    const tableComponents = useMemo(
        () => createVirtuosoTableComponents<R>(),
        [],
    );

    const fixedHeaderContent = useMemo(
        () => (() => createFixedHeaderContent(columns)),
        [columns],
    );

    const rowContent = useMemo(
        () => createRowContent(columns, id),
        [columns, id]
    );

    return (
        <TableVirtuoso
            useWindowScroll
            data={rows}
            components={tableComponents}
            fixedHeaderContent={fixedHeaderContent}
            itemContent={rowContent}
            totalCount={rows.length}
        />
    )
}
